// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "._1gHbxgReXOUphH {\n  align-items: center;\n  align-self: stretch;\n  color: #172B4D;\n  display: flex;\n  font-size: 1.4rem;\n  padding: 0.5rem 1.5rem;\n  text-decoration: none;\n}\n._1gHbxgReXOUphH:hover {\n  color: #172B4D;\n}\n._1FqyZcv0FYUuyC {\n  background-color: #0065ff;\n  color: #FFFFFF;\n}\n._1FqyZcv0FYUuyC:hover {\n  background-color: #0747a6;\n  color: #FFFFFF;\n}\n.ceV4PqBR2LrMii {\n  align-items: stretch;\n  display: flex;\n  margin-left: auto;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"buttonLink": "_1gHbxgReXOUphH",
	"primaryButtonLink": "_1FqyZcv0FYUuyC",
	"buttonGroup": "ceV4PqBR2LrMii"
};
export default ___CSS_LOADER_EXPORT___;
